import { PERMISSIONS } from "../../../store/userStore/permissions.enum";
import { CheckPermission } from "../../../requests/CheckPermission";
import GlobalSettingsForm from "../GlobalSettingsForm";
import HorizontalPanel from "../../../components/HorizontalPanel";
import TrialTime from "../TrialTime";
import SettingsWhitelist from "../SettingsWhitelist";
import LoginLinks from "../LoginLinks";
import SystemMessageSettings from "../SystemMessageSettings";
import ExportSettings from "../ExportSettings";

const GlobalAppSettings = () => {
  return (
    <CheckPermission permissionName={PERMISSIONS.GLOBAL_SETTINGS_ACTIONS}>
      <HorizontalPanel size={HorizontalPanel.SIZES.WHOLE_SPACE}>
        <TrialTime />
        <GlobalSettingsForm />
        <ExportSettings />
        <LoginLinks />
        <SystemMessageSettings />
        <SettingsWhitelist />
      </HorizontalPanel>
    </CheckPermission>
  );
}

export default GlobalAppSettings;